import {
  configureStore,
  EnhancedStore,
  MiddlewareArray,
  ThunkMiddleware,
} from '@reduxjs/toolkit';
import { AnyAction, Reducer } from 'redux';

export type StoreType<T> = EnhancedStore<
  T,
  AnyAction,
  MiddlewareArray<[ThunkMiddleware<T, AnyAction, undefined>]>
>;

export let store: EnhancedStore<
  {
    [key: string]: any;
  },
  AnyAction,
  MiddlewareArray<
    [
      ThunkMiddleware<
        {
          [key: string]: any;
        },
        AnyAction,
        undefined
      >
    ]
  >
>;

export type ReducersInjectorWithState<TState extends { [key: string]: any }> =
  () => {
    name: keyof TState;
    reducer: Reducer;
  }[];
type ReducerInjector = ReducersInjectorWithState<{
  [key: string]: any;
}>;

export const createStore = (reducers: ReducerInjector[]) => {
  const _reducers: { [key: string]: Reducer } = {};
  for (let index = 0; index < reducers.length; index++) {
    const reducerObjects = reducers[index]();
    for (let j = 0; j < reducerObjects.length; j++) {
      const reducerObject = reducerObjects[j];

      _reducers[reducerObject.name] = reducerObject.reducer;
    }
  }
  store = configureStore({
    reducer: {
      ..._reducers,
    },
    middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      });
    },
  });

  return store;
};

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
